var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "19",
        height: "22",
        viewBox: "0 0 19 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M9.48844 3.72852C7.79974 3.72808 6.14153 4.15035 4.68506 4.95171C3.2286 5.75307 2.02669 6.90447 1.20347 8.28699C0.380246 9.66951 -0.0344391 11.233 0.00223815 12.8161C0.0389154 14.3991 0.525626 15.9443 1.4121 17.2919L0.661056 21.1507C0.638982 21.2668 0.647096 21.3861 0.684708 21.4986C0.72232 21.6112 0.788321 21.7135 0.877111 21.797C0.949201 21.8629 1.03451 21.9147 1.12811 21.9495C1.22171 21.9843 1.32173 22.0013 1.42239 21.9996H1.57672L6.55627 21.0349C7.49661 21.3594 8.48687 21.5385 9.48844 21.5655C12.0111 21.5655 14.4304 20.6259 16.2141 18.9533C17.9979 17.2808 19 15.0123 19 12.647C19 10.2817 17.9979 8.01322 16.2141 6.34068C14.4304 4.66814 12.0111 3.72852 9.48844 3.72852Z",
          fill: "#5625CC",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9.81913 2.26367C10.1226 2.26367 10.3686 2.50253 10.3686 2.79718V6.03156C10.3686 6.32621 10.1226 6.56507 9.81913 6.56507C9.51566 6.56507 9.26965 6.32621 9.26965 6.03156V2.79718C9.26965 2.50253 9.51566 2.26367 9.81913 2.26367Z",
          fill: "#5625CC",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.4676 1.60052C11.4676 2.48446 10.7296 3.20104 9.8192 3.20104C8.9088 3.20104 8.17078 2.48446 8.17078 1.60052C8.17078 0.716577 8.9088 0 9.8192 0C10.7296 0 11.4676 0.716577 11.4676 1.60052Z",
          fill: "#5625CC",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.74182 10.8748C8.74182 11.6114 8.1268 12.2085 7.36813 12.2085C6.60947 12.2085 5.99445 11.6114 5.99445 10.8748C5.99445 10.1382 6.60947 9.54102 7.36813 9.54102C8.1268 9.54102 8.74182 10.1382 8.74182 10.8748Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.9744 10.8748C14.9744 11.6114 14.3593 12.2085 13.6007 12.2085C12.842 12.2085 12.227 11.6114 12.227 10.8748C12.227 10.1382 12.842 9.54102 13.6007 9.54102C14.3593 9.54102 14.9744 10.1382 14.9744 10.8748Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.70583 13.7852L8.172 14.2379C9.39563 15.4264 11.3805 15.4263 12.6045 14.2379L13.0708 13.7852L14.0033 14.6905L13.537 15.1432C11.7981 16.8316 8.97817 16.832 7.23936 15.1432L6.77319 14.6904L7.70583 13.7852Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }